<template>
    <component
        :is="menuName || 'selectSticker'"
        :dataInstagramDefault="dataInstagramDefault"
        :stickers="stickers"
        :pagesSelectedIncludeConciergerie="pagesSelectedIncludeConciergerie"
        @addSticker="addSticker"
        @changeMenu="changeMenu"
    />
</template>

<script>

import selectSticker from './SelectStickerMenu.vue';
import locationMenu from './LocationMenu.vue';
import musicMenu from './MusicMenu.vue';
import linkMenu from './LinkMenu.vue';
import imageMenu from './ImageMenu.vue';
import gifMenu from './GifMenu.vue';
import productMenu from './ProductMenu.vue';
import postMenu from './PostMenu.vue';

import { formatDateToYYYYMMDD } from '@/utils/Date.js'
export default {
    
    components: {
        selectSticker,
        locationMenu,
        musicMenu,
        linkMenu,
        imageMenu,
        gifMenu,
        productMenu,
        postMenu
    },
    
    props: {
        menuNameDefault: {
            type: String,
            default: ''
        },
        stickers: Array,
        dataInstagramDefault: Object,
        pagesSelectedIncludeConciergerie: Number
    },
    
    data() {
        return {
            menuName: 'selectSticker'
        }
    },
    
    methods: {
        addSticker(name, custom = {}) {
            if (!stickerDataDefault[name]) return
            const data = {...JSON.parse(JSON.stringify(stickerDataDefault[name])), ...custom}
            if (name === 'survey' && data.data) {
                data.data.responses = [this.$t('dash.post-creator.story.survey-yes'), this.$t('dash.post-creator.story.survey-no')]
            }
            this.$emit('addSticker', data)
            this.$emit('close');
        },

        changeMenu(menuName) {
            this.menuName = menuName
            if (!menuName) {
                this.$emit('close');
            }
        }
    },

    watch: {
        menuNameDefault: {
            handler(newValue) {
                this.menuName = newValue
            },
            immediate: true
        }
    },
}

export const stickerDataDefault = {

    "text": {
        type:'text',
        isEditing: true,
        position : {
            x: 50,
            y: 50
        },
        
        transform: {
            rotate: 0,
            scale: 1
        },
        
        data : {
            text: '',
            mentions: {},
            font: 'modern-font',
            align: 'center',
            color: '#fff',
            fontSize: 27.5,
            background : 'secondary'
        },
    },

    "survey": {
        type:'survey',
        isEditing: true,
        position : {
            x: 50,
            y: 50
        },
        
        transform: {
            rotate: 0,
            scale: 1
        },
        
        data : {
            question : '',
            responses : ['oui','non'],
            color : '#0C0F14',
        },
    },
    
    "location": {
        type:'location',
        isEditing: false,
        position : {
            x: 50,
            y: 50
        },
        
        transform: {
            rotate: 0,
            scale: 1
        },
        
        data : {
            place : {},
            styleVariant: 1
        },
    },
    
    "mention": {
        type:'mention',
        isEditing: true,
        position : {
            x: 50,
            y: 50
        },
        
        transform: {
            rotate: 0,
            scale: 1
        },
        
        data : {
            mention : null,
            isHide: false,
            styleVariant: 1
        },
    },
    
    "slider": {
        type:'slider',
        isEditing: true,
        position : {
            x: 50,
            y: 50
        },
        
        transform: {
            rotate: 0,
            scale: 1
        },
        
        data : {
            quesion : '',
            emoji: '😍',
            color: '#FFFFFF',
        },
    },
    "hashtag": {
        type:'hashtag',
        isEditing: true,
        position : {
            x: 50,
            y: 50
        },
        
        transform: {
            rotate: 0,
            scale: 1
        },
        
        data : {
            hashtag : '',
            styleVariant: 1
        },
    },
    "link": {
        type:'link',
        isEditing: false,
        position : {
            x: 50,
            y: 50
        },
        
        transform: {
            rotate: 0,
            scale: 1
        },
        
        data : {
            link : '',
            text: '',
            styleVariant: 1
        },
    },
    "product": {
        type:'product',
        isEditing: false,
        position : {
            x: 50,
            y: 50
        },
        
        transform: {
            rotate: 0,
            scale: 1
        },
        
        data : {
            products : [],
            font: 'classic-font',
            color: '#4396F6',
            styleVariant: 1
        },
    },
    "image": {
        type:'image',
        isEditing: false,
        position : {
            x: 50,
            y: 50
        },
        
        transform: {
            rotate: 0,
            scale: 1
        },
        
        data : {
            idFile: null,
        },
    },
    "gif": {
        type:'gif',
        isEditing: false,
        position : {
            x: 50,
            y: 50
        },
        
        transform: {
            rotate: 0,
            scale: 1
        },
        
        data : {
            gif: null,
        },
    },

    "music": {
        type:'music',
        isEditing: true,
        position : {
            x: 50,
            y: 50
        },
        
        transform: {
            rotate: 0,
            scale: 1
        },
        
        data : {
            music: null,
            styleVariant: 1,
            rangeDuration: null,
            start: 0
        },
    },

    "post": {
        type:'post',
        isEditing: false,
        disableIncreaseZIndex: true,
        disableDelete: true,
        position : {
            x: 50,
            y: 50
        },
        
        transform: {
            rotate: 0,
            scale: 1
        },
        
        data : {
            idFile: null,
            typePost: 'simple', //carousel, video, reel, simple
            styleVariant: 1,
            textContent: ''
        },
    },
    "question": {
        type:'question',
        isEditing: true,
        position : {
            x: 50,
            y: 50
        },
        
        transform: {
            rotate: 0,
            scale: 1
        },
        
        data : {
            question: '',
            color: '#FFFFFF',
        },
    },
    "countdown": {
        type:'countdown',
        isEditing: true,
        position : {
            x: 50,
            y: 50
        },
        
        transform: {
            rotate: 0,
            scale: 1
        },
        
        data : {
            name : '',
            date : formatDateToYYYYMMDD(new Date(Date.now() + 1000 * 60 * 60 * 24)),
            hours : false,
            minutes: false,
            color: '#FFFFFF',
        },
    }
}

</script>